import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";
import { mediaUrl } from "@/lib/api";

export default function Logo({ compact = false }) {
  const { settings } = useSettings();
  const name = settings?.site_name || "7 LEGENDARY";
  const tagline = settings?.tagline || "FUTURE OF GAMING";
  const logoUrl = settings?.logo_url;
  const parts = name.split(" ");
  const first = parts[0];
  const rest = parts.slice(1).join(" ");

  return (
    <Link to="/" data-testid="site-logo" className="flex items-center gap-2 group">
      {logoUrl ? (
        <img src={mediaUrl(logoUrl)} alt={name} className="h-8 w-auto" />
      ) : (
        <>
          <span
            className="font-head text-2xl font-bold leading-none"
            style={{ color: "hsl(var(--accent))" }}
          >
            {first}
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-head text-lg font-bold tracking-wide text-white">{rest || name}</span>
            {!compact && (
              <span className="text-[9px] tracking-[0.25em] text-white/50 font-semibold">{tagline}</span>
            )}
          </span>
        </>
      )}
    </Link>
  );
}
